// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Classes */
body {
    font-family: 'Figtree', sans-serif !important;
    background: linear-gradient(to right, #f4f4f4, #ffffff);
}

.MuiTabs-indicator {
    background-color: #fafafa !important; /* Yellow */
}

.css-19wsa2m-MuiButtonBase-root-MuiTab-root {
    font-family: 'Figtree', sans-serif !important;
}

.horizontal_fill
{
    width: 100%;
}

.flex_column
{
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
}

.flex_row
{
    display: flex;
    flex-flow: row;
    height: 100%;
    width: 100%;
}

.flex_fill
{
    flex: 1 1;
}

.center
{
    text-align: center;
}

.center_image 
{
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.expander
{
    width: 100%;
    height: 100%;
}

.shrink
{
    margin: 0px;
    border: 0px;
    padding: 0px;
}

.buffer32
{
    padding: 32px;
}

.debug_grid
{
    text-align: center;
    border: 2px black dashed;
}

.graph_title
{
    color: white;
    background-color: rgb(1, 30, 65);
    border: 1px solid gray;
}

/* Homepage & Globals */
#div_menu
{
    position: fixed;
    left: 0px;
    top: 0px;
    height: 64px;
    width: 100%;
    color: white;
    background-color: rgb(1, 30, 65);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
}

#div_menu img {
    max-width: 150px;
    max-height: 150px;
    object-fit: contain;
}

#tabs {
    width: auto;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
}

#tabs button {
    transition: color 0.3s ease-in-out;
}

#tabs button:hover {
    color: #4c84ae;
}

#div_content
{
    position: fixed;
    left: 0px;
    top: 64px;
    width: 100%;
    height: calc(100% - 96px);
    overflow-y:auto;
    color: black;
    background-color: white;
}

#div_content h2
{
    color: rgb(1, 30, 65);
}

#div_footer
{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 40px; 
    color: white;
    background-color: rgb(1, 30, 65);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    opacity: 0;
    z-index: 10;
}

#div_footer.hidden {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
}

#div_footer.visible {
    opacity: 1;
    visibility: visible;
}

#div_footer table {
    width: 100%;
}

#footer_text
{
    margin: 0px;
    text-align: left;
    font-size: 14px; 
}

#div_footer img {
    width: 150px; 
    height: 32px; 
    object-fit: contain;
    display: block;
}

#img_passur
{
    position: fixed;
    bottom: 0px;
    right: 0px;
}

[role="tabpanel"]
{
    width: 100%;
    height: 100%;
}

#div_content > div
{
    padding: 0px;
}

#tabs > div > div > button
{
    color: white;
}

/* Position the arrows properly */
.slider-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: white;
    color: navy;
    border-radius: 50%;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

/* Move arrows to the left and right */
.slider-arrow-left {
    left: -40px; /* Push the left arrow out slightly */
}

.slider-arrow-right {
    right: -40px; /* Push the right arrow out slightly */
}

/*Airport Data*/
.airport_data_container {
    position: relative;
    width: 100%;
    height: 100px;
    overflow: hidden;
    border-radius: 15px 15px 0 0;
}

/* Wrapper for the image */
.airport_data_image-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1; /* Behind text */
    border-radius: 15px 15px 0 0;
    overflow: hidden;
}

/* Image with bottom alignment */
.airport_data_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center bottom;
    filter: brightness(50%);
    border-radius: 15px 15px 0 0;
}

/* Overlay using ::before */
.airport_data_image-wrap::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 102, 204, .6); /* Blue overlay */
    z-index: 2; /* Above the image, behind text */
    border-radius: 15px 15px 0 0;
}

/* Text Content */
.airport_data_text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 3; /* Above overlay */
    width: 80%;
}

.airport_data_text h1 {
    font-weight: bold;
    margin-bottom: 10px;
}

.airport_data_text p {
    font-size: 1.2em;
    max-width: 800px;
    margin: 0 auto;
}

/* Home Welcome Widget */
.home_welcome_container {
    position: relative;
    color: white;
    width: 100%;
    height: 150px; /* Adjust based on how much text you have */
    overflow: hidden; /* Ensures no overflow issues */
}

/* Create a wrapper for the image */
.home_welcome_image-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1; /* Behind the text */
}


.home_welcome_container::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3; /* Ensures it sits above the image */
    background: linear-gradient(rgba(1, 30, 65, 0.3), rgba(8, 38, 71, 0.6));
}

.home_welcome_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center bottom;
    filter: brightness(50%);
}

.home_welcome_text {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 80%;
    z-index: 3;
}

.home_welcome_text h1 {
    color: white;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
}

.home_welcome_text p {
    color: white;
    margin-bottom: 10px;
    text-align: left; /* Align text to the left */
    margin: 0; /* Remove auto-centering */
    flex: 1 1; 
    font-weight: bold;
}

.home_welcome_text button {
    all: unset;
    color: #4c84ae; /* Yellow color */
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    display: inline-block; /* Ensures it stays next to the paragraph */
    margin-left: 10px; /* Moves button next to text */
    flex-shrink: 0;
}

.home_welcome_text button:hover {
    color: white;
}

.home_welcome_text a {
    all: unset;
    color: #4c84ae; /* Yellow color */
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    display: inline-block; /* Ensures it stays next to the paragraph */
    margin-left: 10px; /* Moves button next to text */
    flex-shrink: 0;
}

.home_welcome_text a:hover {
    color: white;
}

/* Tab Link Welcome*/
#widget_tab_link_home_welcome button {
    all: unset;
    color: rgb(0, 102, 204);
    text-decoration: none;
    transition: 0.3s ease-in-out;
    font-weight: bold;
    cursor: pointer;
}

#widget_tab_link_home_welcome button:hover {
    text-decoration: underline;
}

#widget_tab_link_home_welcome h1 {
    color: rgb(1, 30, 65);
}

/* Tab Link Flight Tracker*/
#widget_tab_link_home_flight_link button {
    all: unset;
    color: rgb(0, 102, 204);
    text-decoration: none;
    transition: 0.3s ease-in-out;
    font-weight: bold;
    cursor: pointer;
}

#widget_tab_link_home_flight_link button:hover {
    text-decoration: underline;
}

#widget_tab_link_home_flight_link h1 {
    color: rgb(1, 30, 65);
}

/* Tab Link Complaint*/
#widget_tab_link_home_complaint {
    background-color: rgb(44, 187, 174);
    border-radius: 15px;
    padding: 10px;
}

#widget_tab_link_home_complaint button {
    padding: 3px 6px;
    background-color: #fafafa;
    color: #011E41;
}

#widget_tab_link_home_complaint button:hover {
    background-color: rgb(1, 30, 65);
    border-color: #257dfd;
    color: #4c84ae;
}

#widget_tab_link_home_complaint h1 {
    color: rgb(1, 30, 65);
}

/* FAQ Widget */
#widget_accordion_faq
{
    padding: 32px;
    width: auto;
}

#widget_accordion_faq > div 
{
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
    background-color:  rgb(1, 30, 65);
    border: 1px solid black;
}

#widget_accordion_faq h2 
{
    color: rgb(1, 30, 65);
}

#widget_accordion_faq > div > h3 > div
{
    color: white;
    background-color:  rgb(1, 30, 65);
}

#widget_accordion_faq a {
    all: unset;
    color: #4c84ae; /* Yellow color */
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    display: inline-block; /* Ensures it stays next to the paragraph */
    margin-left: 10px; /* Moves button next to text */
    flex-shrink: 0;
}

#widget_accordion_faq a:hover {
    color: white;
}

#widget_accordion_runways
{
    padding: 32px;
    width: auto;
}

#widget_accordion_runways > div 
{
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
    background-color:  rgb(1, 30, 65);
    border: 1px solid black;
}

#widget_accordion_runways h2 
{
    color: rgb(1, 30, 65);
}

/* Complaint Widget */
#widget_complaint
{
    padding: 32px;
}

#widget_complaint > table
{
    padding: 5px;
    background-color: gainsboro;
    border: 1px solid black;
    border-radius: 12px;
}

#widget_complaint > table > tbody > tr > td
{
    padding: 5px;
}

#textfield_first_name
{
    width: 150px;
}

#textfield_last_name
{
    width: 150px;
}

#textfield_city
{
    width: 150px;
}

#textfield_zip
{
    width: 100px;
}

#textfield_address
{
    width: 250px;
}

#textfield_description
{
    width: 450px;
    height: 150px;
}

#button_save
{
    float: right;
    width: 200px;
}

/* Mobile Complaint Widget */
#widget_mobile_complaint
{
    padding: 16px;
}

#widget_mobile_complaint > table
{
    padding: 5px;
    background-color: gainsboro;
    border: 1px solid black;
    border-radius: 12px;
}

#widget_mobile_complaint > table > tbody > tr > td > h3
{
    margin: 0px;
}

#widget_mobile_complaint > table > tbody > tr > td
{
    padding: 4px;
}

#portal_help h2
{
    color: rgb(1, 30, 65);
}

#runway_config {
  box-shadow: 5px 5px 15px rgba(0,0,0,.3);
  border-radius: 15px;
  /* pick a height that fits your layout; clamp keeps it responsive */
  height: clamp(420px, 68vh, 900px);
  overflow: hidden; /* keep everything inside the rounded card */
}

#runway_config h2
{
    text-align: center;
    color: rgb(1, 30, 65);
    margin: 8px 0; 
}

#runway_config .html-widget-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

/* Only the image area scrolls */
#runway_config .img-scroll {
  flex: 1 1 auto;              /* <-- key: fills remaining height */
  min-height: 0;               /* <-- allow it to actually shrink/grow */
  overflow: auto;              /* scrollbars as needed */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 6px 10px 10px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* IMAGE — keep native detail and show it “closer” */
#runway_config .airport-layout-img {
  display: block;
  max-width: none;                 /* don't shrink to container */
  height: auto;
  /* feels close on desktop but still responsive on smaller widths */
  width: 1300px;
}

#publicvue_lna {
    border-radius: 15px; 
    overflow: hidden;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); 
}

#graphs_1x {
    border-radius: 0 0 15px 15px; 
    overflow: visible !important; 
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
    color: white; 
}

#graphs_1x h2{
    color: white; 
}

#graphs_2x {
    border-radius: 0 0 15px 15px;  
    overflow: visible !important; 
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); 
    color: white;
}

#graphs_2x h2{
    color: white;
}

#graphs_3x {
    border-radius: 0 0 15px 15px;  
    overflow: visible !important; 
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
    color: white; 
}

#graphs_3x h2{
    color: white; 
}

.date-filter-container {
    background-color: #002147;
    border-radius: 4px;
    padding-top: 20px;
    max-width: 300px;
    color: white;
    font-family: inherit;
  }
  
  .date-filter-label {
    color: white;
    margin-bottom: 8px;
  }
  
  .date-filter-input-label {
    color: white !important;
  }
  
  .date-filter-select {
    color: white;
  }
  
  .date-filter-select .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }
  
  .date-filter-select.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #80bdff;
  }
  
  .date-filter-select:hover .MuiOutlinedInput-notchedOutline {
    border-color: #80bdff;
  }
  
  .date-filter-select .MuiSvgIcon-root {
    color: white;
  }
  
  .date-filter-select .MuiSelect-select {
    color: white;
  }

  
  .date-filter-select .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }

  .slider-widget-filter-bar {
    width: 100%;
    background-color: #002147;
    padding: 12px 40px;
    box-sizing: border-box;
  }

  @media screen and (max-width: 768px) {
  .home_welcome_text h1 {
        font-size: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/config/lna.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,6CAA6C;IAC7C,uDAAuD;AAC3D;;AAEA;IACI,oCAAoC,EAAE,WAAW;AACrD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,SAAO;AACX;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;;IAEI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,SAAS;IACT,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;IACf,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,WAAW;AACf;;AAEA,sCAAsC;AACtC;IACI,WAAW,EAAE,qCAAqC;AACtD;;AAEA;IACI,YAAY,EAAE,sCAAsC;AACxD;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU,EAAE,gBAAgB;IAC5B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC,EAAE,iBAAiB;IACpD,UAAU,EAAE,iCAAiC;IAC7C,4BAA4B;AAChC;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,UAAU,EAAE,kBAAkB;IAC9B,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa,EAAE,2CAA2C;IAC1D,gBAAgB,EAAE,+BAA+B;AACrD;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU,EAAE,oBAAoB;AACpC;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU,EAAE,oCAAoC;IAChD,uEAAuE;AAC3E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,8BAA8B;IAC9B,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB,EAAE,2BAA2B;IAC7C,SAAS,EAAE,0BAA0B;IACrC,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc,EAAE,iBAAiB;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,qBAAqB,EAAE,2CAA2C;IAClE,iBAAiB,EAAE,8BAA8B;IACjD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc,EAAE,iBAAiB;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,qBAAqB,EAAE,2CAA2C;IAClE,iBAAiB,EAAE,8BAA8B;IACjD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,eAAe;AACf;;IAEI,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,cAAc,EAAE,iBAAiB;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,qBAAqB,EAAE,2CAA2C;IAClE,iBAAiB,EAAE,8BAA8B;IACjD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;;IAEI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;;IAEI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,mEAAmE;EACnE,iCAAiC;EACjC,gBAAgB,EAAE,4CAA4C;AAChE;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,cAAc,eAAe,oCAAoC;EACjE,aAAa,gBAAgB,yCAAyC;EACtE,cAAc,eAAe,yBAAyB;EACtD,iCAAiC;EACjC,4BAA4B;EAC5B,sBAAsB;;EAEtB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,eAAe,kBAAkB,8BAA8B;EAC/D,YAAY;EACZ,kEAAkE;EAClE,aAAa;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;EACA;QACM,eAAe;EACrB;AACF","sourcesContent":["/* Common Classes */\nbody {\n    font-family: 'Figtree', sans-serif !important;\n    background: linear-gradient(to right, #f4f4f4, #ffffff);\n}\n\n.MuiTabs-indicator {\n    background-color: #fafafa !important; /* Yellow */\n}\n\n.css-19wsa2m-MuiButtonBase-root-MuiTab-root {\n    font-family: 'Figtree', sans-serif !important;\n}\n\n.horizontal_fill\n{\n    width: 100%;\n}\n\n.flex_column\n{\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    width: 100%;\n}\n\n.flex_row\n{\n    display: flex;\n    flex-flow: row;\n    height: 100%;\n    width: 100%;\n}\n\n.flex_fill\n{\n    flex: 1;\n}\n\n.center\n{\n    text-align: center;\n}\n\n.center_image \n{\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.expander\n{\n    width: 100%;\n    height: 100%;\n}\n\n.shrink\n{\n    margin: 0px;\n    border: 0px;\n    padding: 0px;\n}\n\n.buffer32\n{\n    padding: 32px;\n}\n\n.debug_grid\n{\n    text-align: center;\n    border: 2px black dashed;\n}\n\n.graph_title\n{\n    color: white;\n    background-color: rgb(1, 30, 65);\n    border: 1px solid gray;\n}\n\n/* Homepage & Globals */\n#div_menu\n{\n    position: fixed;\n    left: 0px;\n    top: 0px;\n    height: 64px;\n    width: 100%;\n    color: white;\n    background-color: rgb(1, 30, 65);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 15px;\n}\n\n#div_menu img {\n    max-width: 150px;\n    max-height: 150px;\n    object-fit: contain;\n}\n\n#tabs {\n    width: auto;\n    flex-grow: 1;\n    display: flex;\n    justify-content: space-between;\n}\n\n#tabs button {\n    transition: color 0.3s ease-in-out;\n}\n\n#tabs button:hover {\n    color: #4c84ae;\n}\n\n#div_content\n{\n    position: fixed;\n    left: 0px;\n    top: 64px;\n    width: 100%;\n    height: calc(100% - 96px);\n    overflow-y:auto;\n    color: black;\n    background-color: white;\n}\n\n#div_content h2\n{\n    color: rgb(1, 30, 65);\n}\n\n#div_footer\n{\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 40px; \n    color: white;\n    background-color: rgb(1, 30, 65);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 15px;\n    opacity: 0;\n    z-index: 10;\n}\n\n#div_footer.hidden {\n    opacity: 0;\n    pointer-events: none;\n    visibility: hidden;\n}\n\n#div_footer.visible {\n    opacity: 1;\n    visibility: visible;\n}\n\n#div_footer table {\n    width: 100%;\n}\n\n#footer_text\n{\n    margin: 0px;\n    text-align: left;\n    font-size: 14px; \n}\n\n#div_footer img {\n    width: 150px; \n    height: 32px; \n    object-fit: contain;\n    display: block;\n}\n\n#img_passur\n{\n    position: fixed;\n    bottom: 0px;\n    right: 0px;\n}\n\n[role=\"tabpanel\"]\n{\n    width: 100%;\n    height: 100%;\n}\n\n#div_content > div\n{\n    padding: 0px;\n}\n\n#tabs > div > div > button\n{\n    color: white;\n}\n\n/* Position the arrows properly */\n.slider-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: white;\n    color: navy;\n    border-radius: 50%;\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\n    z-index: 10;\n}\n\n/* Move arrows to the left and right */\n.slider-arrow-left {\n    left: -40px; /* Push the left arrow out slightly */\n}\n\n.slider-arrow-right {\n    right: -40px; /* Push the right arrow out slightly */\n}\n\n/*Airport Data*/\n.airport_data_container {\n    position: relative;\n    width: 100%;\n    height: 100px;\n    overflow: hidden;\n    border-radius: 15px 15px 0 0;\n}\n\n/* Wrapper for the image */\n.airport_data_image-wrap {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1; /* Behind text */\n    border-radius: 15px 15px 0 0;\n    overflow: hidden;\n}\n\n/* Image with bottom alignment */\n.airport_data_image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center bottom;\n    filter: brightness(50%);\n    border-radius: 15px 15px 0 0;\n}\n\n/* Overlay using ::before */\n.airport_data_image-wrap::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 102, 204, .6); /* Blue overlay */\n    z-index: 2; /* Above the image, behind text */\n    border-radius: 15px 15px 0 0;\n}\n\n/* Text Content */\n.airport_data_text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: white;\n    z-index: 3; /* Above overlay */\n    width: 80%;\n}\n\n.airport_data_text h1 {\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.airport_data_text p {\n    font-size: 1.2em;\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n/* Home Welcome Widget */\n.home_welcome_container {\n    position: relative;\n    color: white;\n    width: 100%;\n    height: 150px; /* Adjust based on how much text you have */\n    overflow: hidden; /* Ensures no overflow issues */\n}\n\n/* Create a wrapper for the image */\n.home_welcome_image-wrap {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1; /* Behind the text */\n}\n\n\n.home_welcome_container::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 3; /* Ensures it sits above the image */\n    background: linear-gradient(rgba(1, 30, 65, 0.3), rgba(8, 38, 71, 0.6));\n}\n\n.home_welcome_image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center bottom;\n    filter: brightness(50%);\n}\n\n.home_welcome_text {\n    position: absolute;\n    top: 0%;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    width: 80%;\n    z-index: 3;\n}\n\n.home_welcome_text h1 {\n    color: white;\n    font-weight: bold;\n    margin-bottom: 10px;\n    text-align: center;\n}\n\n.home_welcome_text p {\n    color: white;\n    margin-bottom: 10px;\n    text-align: left; /* Align text to the left */\n    margin: 0; /* Remove auto-centering */\n    flex: 1; \n    font-weight: bold;\n}\n\n.home_welcome_text button {\n    all: unset;\n    color: #4c84ae; /* Yellow color */\n    text-decoration: none;\n    font-weight: bold;\n    cursor: pointer;\n    transition: color 0.3s ease-in-out;\n    display: inline-block; /* Ensures it stays next to the paragraph */\n    margin-left: 10px; /* Moves button next to text */\n    flex-shrink: 0;\n}\n\n.home_welcome_text button:hover {\n    color: white;\n}\n\n.home_welcome_text a {\n    all: unset;\n    color: #4c84ae; /* Yellow color */\n    text-decoration: none;\n    font-weight: bold;\n    cursor: pointer;\n    transition: color 0.3s ease-in-out;\n    display: inline-block; /* Ensures it stays next to the paragraph */\n    margin-left: 10px; /* Moves button next to text */\n    flex-shrink: 0;\n}\n\n.home_welcome_text a:hover {\n    color: white;\n}\n\n/* Tab Link Welcome*/\n#widget_tab_link_home_welcome button {\n    all: unset;\n    color: rgb(0, 102, 204);\n    text-decoration: none;\n    transition: 0.3s ease-in-out;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n#widget_tab_link_home_welcome button:hover {\n    text-decoration: underline;\n}\n\n#widget_tab_link_home_welcome h1 {\n    color: rgb(1, 30, 65);\n}\n\n/* Tab Link Flight Tracker*/\n#widget_tab_link_home_flight_link button {\n    all: unset;\n    color: rgb(0, 102, 204);\n    text-decoration: none;\n    transition: 0.3s ease-in-out;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n#widget_tab_link_home_flight_link button:hover {\n    text-decoration: underline;\n}\n\n#widget_tab_link_home_flight_link h1 {\n    color: rgb(1, 30, 65);\n}\n\n/* Tab Link Complaint*/\n#widget_tab_link_home_complaint {\n    background-color: rgb(44, 187, 174);\n    border-radius: 15px;\n    padding: 10px;\n}\n\n#widget_tab_link_home_complaint button {\n    padding: 3px 6px;\n    background-color: #fafafa;\n    color: #011E41;\n}\n\n#widget_tab_link_home_complaint button:hover {\n    background-color: rgb(1, 30, 65);\n    border-color: #257dfd;\n    color: #4c84ae;\n}\n\n#widget_tab_link_home_complaint h1 {\n    color: rgb(1, 30, 65);\n}\n\n/* FAQ Widget */\n#widget_accordion_faq\n{\n    padding: 32px;\n    width: auto;\n}\n\n#widget_accordion_faq > div \n{\n    margin-top: 0px;\n    margin-bottom: 0px;\n    color: white;\n    background-color:  rgb(1, 30, 65);\n    border: 1px solid black;\n}\n\n#widget_accordion_faq h2 \n{\n    color: rgb(1, 30, 65);\n}\n\n#widget_accordion_faq > div > h3 > div\n{\n    color: white;\n    background-color:  rgb(1, 30, 65);\n}\n\n#widget_accordion_faq a {\n    all: unset;\n    color: #4c84ae; /* Yellow color */\n    text-decoration: none;\n    font-weight: bold;\n    cursor: pointer;\n    transition: color 0.3s ease-in-out;\n    display: inline-block; /* Ensures it stays next to the paragraph */\n    margin-left: 10px; /* Moves button next to text */\n    flex-shrink: 0;\n}\n\n#widget_accordion_faq a:hover {\n    color: white;\n}\n\n#widget_accordion_runways\n{\n    padding: 32px;\n    width: auto;\n}\n\n#widget_accordion_runways > div \n{\n    margin-top: 0px;\n    margin-bottom: 0px;\n    color: white;\n    background-color:  rgb(1, 30, 65);\n    border: 1px solid black;\n}\n\n#widget_accordion_runways h2 \n{\n    color: rgb(1, 30, 65);\n}\n\n/* Complaint Widget */\n#widget_complaint\n{\n    padding: 32px;\n}\n\n#widget_complaint > table\n{\n    padding: 5px;\n    background-color: gainsboro;\n    border: 1px solid black;\n    border-radius: 12px;\n}\n\n#widget_complaint > table > tbody > tr > td\n{\n    padding: 5px;\n}\n\n#textfield_first_name\n{\n    width: 150px;\n}\n\n#textfield_last_name\n{\n    width: 150px;\n}\n\n#textfield_city\n{\n    width: 150px;\n}\n\n#textfield_zip\n{\n    width: 100px;\n}\n\n#textfield_address\n{\n    width: 250px;\n}\n\n#textfield_description\n{\n    width: 450px;\n    height: 150px;\n}\n\n#button_save\n{\n    float: right;\n    width: 200px;\n}\n\n/* Mobile Complaint Widget */\n#widget_mobile_complaint\n{\n    padding: 16px;\n}\n\n#widget_mobile_complaint > table\n{\n    padding: 5px;\n    background-color: gainsboro;\n    border: 1px solid black;\n    border-radius: 12px;\n}\n\n#widget_mobile_complaint > table > tbody > tr > td > h3\n{\n    margin: 0px;\n}\n\n#widget_mobile_complaint > table > tbody > tr > td\n{\n    padding: 4px;\n}\n\n#portal_help h2\n{\n    color: rgb(1, 30, 65);\n}\n\n#runway_config {\n  box-shadow: 5px 5px 15px rgba(0,0,0,.3);\n  border-radius: 15px;\n  /* pick a height that fits your layout; clamp keeps it responsive */\n  height: clamp(420px, 68vh, 900px);\n  overflow: hidden; /* keep everything inside the rounded card */\n}\n\n#runway_config h2\n{\n    text-align: center;\n    color: rgb(1, 30, 65);\n    margin: 8px 0; \n}\n\n#runway_config .html-widget-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n/* Only the image area scrolls */\n#runway_config .img-scroll {\n  flex: 1 1 auto;              /* <-- key: fills remaining height */\n  min-height: 0;               /* <-- allow it to actually shrink/grow */\n  overflow: auto;              /* scrollbars as needed */\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding: 6px 10px 10px;\n\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/* IMAGE — keep native detail and show it “closer” */\n#runway_config .airport-layout-img {\n  display: block;\n  max-width: none;                 /* don't shrink to container */\n  height: auto;\n  /* feels close on desktop but still responsive on smaller widths */\n  width: 1300px;\n}\n\n#publicvue_lna {\n    border-radius: 15px; \n    overflow: hidden;\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); \n}\n\n#graphs_1x {\n    border-radius: 0 0 15px 15px; \n    overflow: visible !important; \n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);\n    color: white; \n}\n\n#graphs_1x h2{\n    color: white; \n}\n\n#graphs_2x {\n    border-radius: 0 0 15px 15px;  \n    overflow: visible !important; \n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); \n    color: white;\n}\n\n#graphs_2x h2{\n    color: white;\n}\n\n#graphs_3x {\n    border-radius: 0 0 15px 15px;  \n    overflow: visible !important; \n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);\n    color: white; \n}\n\n#graphs_3x h2{\n    color: white; \n}\n\n.date-filter-container {\n    background-color: #002147;\n    border-radius: 4px;\n    padding-top: 20px;\n    max-width: 300px;\n    color: white;\n    font-family: inherit;\n  }\n  \n  .date-filter-label {\n    color: white;\n    margin-bottom: 8px;\n  }\n  \n  .date-filter-input-label {\n    color: white !important;\n  }\n  \n  .date-filter-select {\n    color: white;\n  }\n  \n  .date-filter-select .MuiOutlinedInput-notchedOutline {\n    border-color: white;\n  }\n  \n  .date-filter-select.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: #80bdff;\n  }\n  \n  .date-filter-select:hover .MuiOutlinedInput-notchedOutline {\n    border-color: #80bdff;\n  }\n  \n  .date-filter-select .MuiSvgIcon-root {\n    color: white;\n  }\n  \n  .date-filter-select .MuiSelect-select {\n    color: white;\n  }\n\n  \n  .date-filter-select .MuiOutlinedInput-notchedOutline {\n    border-color: white;\n  }\n\n  .slider-widget-filter-bar {\n    width: 100%;\n    background-color: #002147;\n    padding: 12px 40px;\n    box-sizing: border-box;\n  }\n\n  @media screen and (max-width: 768px) {\n  .home_welcome_text h1 {\n        font-size: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
